export default {
	components: {
		LogIn: () => import(`./login`),
		Register: () => import(`./register`),
	},
	routes: [],
	subRoutes: {
		main: [
			{
				path: '/password-setup',
				name: 'PasswordSetup',
				component: () => import(`./password-setup`),
			},
		],
	},
};
